
import { ADDCASHPAYMENT, GETCATEGORYWISECOUNTERSALE, GETCOUNTERSALESCUSTOMERS, GETPAYMENTRECEIPT, GETPAYMENTRECEIPTS, GETPAYMENTXLSX, GETUNPAIDBILLS } from "../../utils/api"
import axios from "../../utils/axios";
export const getCategorySalesCustomers=async(param)=>{
    const res=await axios.post(GETCATEGORYWISECOUNTERSALE,param);
    return res;
}